import SideBar from './SideBar'
import SideBarItem from './SideBarItem'
import SideBarTitle from './SideBarTitle'
import SideBarRadio from './SideBarRadio'

SideBar.Item = SideBarItem
SideBar.Title = SideBarTitle
SideBar.Radio = SideBarRadio

export default SideBar